import { stringify } from 'qs';

import { createAsyncAction, fetchAction } from 'src/redux/actions';
import { pullRequest } from 'src/redux/pull-request/schemas';
import type { PullRequest } from 'src/types/pull-requests-table';

type LoadProps = {
  repositoryOwner: string;
  repositorySlug: string;
  bbql: string;
  page: number;
  sort: string | undefined;
};

const FIELDS =
  '+values.participants,-values.description,-values.summary,+values.ai_contribution';

export const LoadPullRequests = createAsyncAction('pullRequestList/LOAD');
export const loadPullRequests = (props: LoadProps) => {
  const { repositoryOwner, repositorySlug, page, sort } = props;

  const query = stringify({
    pagelen: 25,
    fields: FIELDS,
    q: props.bbql,
    sort,
    page,
  });
  const url = `/!api/2.0/repositories/${repositoryOwner}/${repositorySlug}/pullrequests?${query}`;
  const schema = { values: [pullRequest] };

  return fetchAction(LoadPullRequests, { url, schema, takeLatest: true });
};

export const LoadNextPage = 'pullRequestList/loadNextPage';
export const LoadPreviousPage = 'pullRequestList/loadPreviousPage';
export const PageUnload = 'pullRequestList/PageUnload';

export const pageUnload = () => ({ type: PageUnload });

export const UnloadPullRequests = 'pullRequestList/UNLOAD';
export const unloadPullRequests = () => ({
  type: UnloadPullRequests,
});

export const SetHasDeploymentEnvironments =
  'pullRequestList/SET_HAS_DEPLOYMENT_ENVIRONMENTS';
export const setHasDeploymentEnvironments = (value: boolean) => ({
  type: SetHasDeploymentEnvironments,
  payload: { value },
});

export const UpdatePullRequestsWithDeploymentStatus =
  'pullRequestList/UPDATE_PRS_WITH_DEPLOYMENT_STATUS';

export const updatePullRequestsWithDeploymentStatus = (
  pullRequests: Pick<PullRequest, 'links' | 'deployment_status'>[]
) => ({
  type: UpdatePullRequestsWithDeploymentStatus,
  payload: pullRequests,
  meta: {
    schema: [pullRequest],
  },
});

export * from './pull-request-authors';
